import { observer } from "mobx-react"
import { useStore } from "@features/common"
import { dateFormater } from "@lib/date"
import { Collapse } from "react-collapse"
import { useState } from "react"
import { IconArrowDown } from "@lib/icons"
import classNames from "classnames"

type PreviousVersionsProps = {
  versions: string[]
}

export const PreviousVersions = observer(function PreviousVersions(
  props: PreviousVersionsProps,
) {
  const {
    GlobalModel: { getTemplate },
  } = useStore()
  const { versions } = props
  const prevVersionsTitle = getTemplate("versions.prev.title")
  const [isOpened, toggle] = useState(false)

  if (!versions.length) {
    return null
  }

  return (
    <>
      <div className="mt-4 flex items-center" onClick={() => toggle(!isOpened)}>
        <strong className="cursor-pointer inline-flex items-end pb-1">
          {prevVersionsTitle}
        </strong>
        <IconArrowDown
          width={16}
          height={16}
          className={classNames(
            "mt-1 ml-2 w-[16px] h-[16px] transition-transform duration-150 ease-in-out",
            isOpened && "rotate-180",
          )}
        />
      </div>
      <Collapse isOpened={isOpened}>
        <div className="flex flex-col items-start pt-5 gap-1">
          {versions.map((version) => (
            <a
              key={`version-${version}`}
              href={`?effective_date=${version}`}
              className="underline hover:text-gold-300"
            >
              {version
                ? dateFormater(new Date(version), "dd MMMM yyyy", "en")
                : ""}
            </a>
          ))}
        </div>
      </Collapse>
    </>
  )
})
